export default "__VITE_ASSET__8788e0c1__"